const steps = [
  'Sobre o Dispositivo',
  'Sobre o Cliente',
  'Entrega e Coleta',
  'Pagamento',
  'Ordem de Serviço',
];

export default steps;
